import { useSyncExternalStore } from 'react'
import { TLayoutState } from '../../../types/state'
import { LayoutEvent } from '../../constants/enums'
import { LAYOUTSTATE } from '../../state'
import { pubSubLayout } from '../../state/pubSub'

const subLayoutState = (callback: (state: TLayoutState) => void) =>
    pubSubLayout.on(LayoutEvent.LAYOUT_CHANGE, callback)
const getLayoutState = () => LAYOUTSTATE.layout
const getLayoutSelectorState = (key: keyof TLayoutState) => () =>
    LAYOUTSTATE.layout[key]

export const useLayout = () =>
    useSyncExternalStore(subLayoutState, getLayoutState, getLayoutState)

export const useLayoutSelector = <T extends keyof TLayoutState>(
    key: T,
): TLayoutState[T] =>
    useSyncExternalStore(
        subLayoutState,
        getLayoutSelectorState(key),
        getLayoutSelectorState(key),
    )
